import React, { useCallback } from "react"
import PropTypes from "prop-types"
import FormFieldset from "components/FormFieldset"
import { TextField } from "@theconversation/ui"
import errorsPropType from "components/PropTypes/errorsPropType"
import Analytics from "lib/Analytics"
import i18n from "lib/i18n"

const GiftAidDetails = (props) => {
  const { address, errors, onChange, postcode } = props

  const useTracking = (label, propName) =>
    useCallback(() => {
      if (props[propName]) {
        Analytics.trackFormEvent("Donation Form", "Completed", label)
      } else {
        Analytics.trackFormEvent("Donation Form", "Skipped", label)
      }
    }, [label, propName])
  const trackAddress = useTracking("Address", "address")
  const trackPostcode = useTracking("Postcode", "postcode")

  const setAddress = useCallback((event) => onChange({ address: event.target.value }), [onChange])
  const setPostcode = useCallback((event) => onChange({ postcode: event.target.value }), [onChange])

  return (
    <div id="gift-aid" className="base">
      <fieldset id="gift_aid_details">
        <FormFieldset>
          <TextField
            autoComplete
            error={!!errors.address}
            fullWidth
            label={i18n.t("donation.placeholder.your_home_address")}
            helperText={errors.address || i18n.t("donation.hint.gift_aid_required_field")}
            id="donation_address"
            name="donation[address]"
            onBlur={trackAddress}
            onChange={setAddress}
            type="text"
            value={address}
          />
        </FormFieldset>
        <FormFieldset>
          <TextField
            autoComplete
            error={!!errors.postcode}
            fullWidth
            label={i18n.t("donation.placeholder.your_postcode")}
            helperText={errors.postcode || i18n.t("donation.hint.gift_aid_required_field")}
            id="donation_postcode"
            name="donation[postcode]"
            onBlur={trackPostcode}
            onChange={setPostcode}
            type="text"
            value={postcode}
          />
        </FormFieldset>
      </fieldset>
    </div>
  )
}

GiftAidDetails.defaultProps = {
  address: "",
  errors: {},
  onChange: () => {},
  postcode: "",
}

GiftAidDetails.propTypes = {
  address: PropTypes.string,
  errors: errorsPropType,
  onChange: PropTypes.func,
  postcode: PropTypes.string,
}
export default React.memo(GiftAidDetails)
